import React, { useEffect, useRef, useState } from "react";

export const key = "diagonal-frame-fade";

const FRAME_INSET = 18;
const MIN_INNER_SIZE = 20;
const MIN_FRAME_SIZE = FRAME_INSET * 2 + MIN_INNER_SIZE;

export default function DiagonalFrameFade() {
  const layerRef = useRef(null);
  const [showFrame, setShowFrame] = useState(false);

  useEffect(() => {
    const layer = layerRef.current;
    const parent = layer?.parentElement;
    if (!parent) return undefined;

    const updateFrameVisibility = () => {
      const width = parent.clientWidth || parent.offsetWidth || 0;
      const height = parent.clientHeight || parent.offsetHeight || 0;
      setShowFrame(width >= MIN_FRAME_SIZE && height >= MIN_FRAME_SIZE);
    };

    updateFrameVisibility();

    if (typeof ResizeObserver === "undefined") {
      window.addEventListener("resize", updateFrameVisibility);
      return () => window.removeEventListener("resize", updateFrameVisibility);
    }

    const observer = new ResizeObserver(updateFrameVisibility);
    observer.observe(parent);

    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={layerRef}
      aria-hidden="true"
      style={{
        position: "absolute",
        inset: 0,
        pointerEvents: "none",
      }}
    >
      {showFrame && (
        <div
          style={{
            position: "absolute",
            inset: FRAME_INSET,
            border: "2px solid transparent",
            borderImage: "linear-gradient(135deg, var(--color-3), var(--color-4)) 1",
          }}
        />
      )}
    </div>
  );
}
